import { directusClient } from '@src/api/DirectusClient.ts';
import fileService from './FileService';
import type { EmployerBrand } from '@funnellab/shared/src/types/directus.ts';
import type { EmployerBrandCiDocument } from '../queries/employerBrand';
import type { EmployerBrandDto } from '../api.types';

export class EmployerBrandService {
  async createEmployerBrand(
    employerBrandData: Partial<EmployerBrand>,
    owningOrganizationId: string,
  ) {
    const employerBrand = employerBrandData;
    employerBrand.ownerOrganization = owningOrganizationId;

    return directusClient.createEmployerBrand(employerBrand);
  }

  async updateEmployerBrand(
    employerBrandId: string,
    employerBrandData: Partial<EmployerBrandDto>,
  ) {
    return directusClient.updateEmployerBrand(
      employerBrandId,
      employerBrandData,
    );
  }

  async getAllEmployerBrands(): Promise<EmployerBrandDto[]> {
    return directusClient.getAllEmployerBrands();
  }

  async getEmployerBrand(empBrandId: string): Promise<EmployerBrandDto> {
    return directusClient.getEmployerBrand(empBrandId);
  }

  async getPossibleEmployerBrands(
    orgId: string,
  ): Promise<Pick<EmployerBrandDto, 'id' | 'name'>[]> {
    return directusClient.getPossibleEmployerBrands(orgId);
  }

  async addCiDocument(id: string, fileId: string): Promise<EmployerBrandDto> {
    return directusClient.createCIDocument(id, fileId);
  }

  async removeCiDocument(ciDoc: EmployerBrandCiDocument): Promise<void> {
    await directusClient.removeCIDocument(ciDoc.id);
    return fileService.deleteFile(ciDoc.directus_files_id.id);
  }

  async createEmployerBrandBenefit(
    employerBrand_id: string,
    benefits_id: string,
  ) {
    return directusClient.createEmployerBrandBenefit(
      employerBrand_id,
      benefits_id,
    );
  }

  async removeEmployerBrandBenefit(id: number) {
    return directusClient.removeEmployerBrandBenefit(id);
  }
}

const employerBrandService = new EmployerBrandService();
export default employerBrandService;
